import giftImg from "../images/DecathlonPurple/gift.png";
import Button from "../../buttons/Button";
import Translate from "../../localization/Translate";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    addErrorAlert,
    setCustomerMarketingConsent,
    setLoading,
    setMemberMarketingConsent
} from "../../redux/actions";
import {displayPrice} from "../../util/helperFunctions";
import {getProductsTotalSum} from "../../redux/selectors";
export default function ({onDone, vipBasketTotal=false}){
    const conf = window.AppConf?.accountCreation?.optIn ?? {
        "title": "Stay informed!",
        "disclaimer": "<p>*excluding rewards linked to your loyalty program which will always be sent to you.</p><p>by accepting, you consent to the use and storage of your information by Decathlon SE, for the purpose of sending you personalized emails (offers, news, product recommendations). You can find out more and change your choices by connecting to decathlon.fr, “My Account” page.</p>",
        "message": "Do you want to receive your gift vouchers*, offers, promotions, news and advice that suit you?"
    };
    const dispatch = useDispatch();
    const customer = useSelector((state) => state.rootReducer.customer);
    const currency = useSelector((state) => state.rootReducer.currency);
    let total = useSelector((state) => Number(getProductsTotalSum(state.rootReducer.productsInBasket)));
    let loading = useSelector((state) => state.rootReducer.loading);
    let discountAmount = vipBasketTotal === false ? 0 : total - vipBasketTotal;
    let rewardText;
    if(discountAmount > 0 && !loading){
        rewardText = <p style={styles.mainText}>
            <Translate
                id={'You could save an additional ${discountAmount} on this basket by opting into VIP rewards.'}
                values={{
                    discountAmount: displayPrice(discountAmount) + currency
                }}
            />
        </p>
    }

    return <div style={styles.container}>
        {rewardText}
        <div style={styles.title}>{conf.title}<img style={styles.icon} src={giftImg}/></div>
        <p style={styles.mainText} dangerouslySetInnerHTML={{__html: conf.message}}/>
        <p style={styles.disclaimer} dangerouslySetInnerHTML={{__html: conf.disclaimer}}/>
        <Button
            type="button"
            className={"largeButton blueButton"}
            name={<Translate id="yes i'm interested"/>}
            style={{marginRight: "1.43rem"}}
            onClick={() => {
                if(customer?.rawData?.sub) {
                    dispatch(setLoading(true));
                    dispatch(setMemberMarketingConsent(customer.rawData.sub, true, () => {
                        dispatch(setLoading(false));
                        dispatch(setCustomerMarketingConsent(true));
                        onDone();
                    }, () => {
                        dispatch(setLoading(false));
                        dispatch(addErrorAlert("Marketing consent cannot be updated"));
                    }));
                }else {
                    onDone();
                }
            }}
        />
        <Button
            type="button"
            className={"largeButton grayButton"}
            name={<Translate id="no, thank you"/>}
            onClick={() => {
                if(customer?.rawData?.sub && customer?.marketingConsent === "blank") {
                    dispatch(setLoading(true));
                    dispatch(setMemberMarketingConsent(customer.rawData.sub, false, () => {
                        dispatch(setLoading(false));
                        dispatch(setCustomerMarketingConsent(false));
                        onDone();
                    }, () => {
                        dispatch(setLoading(false));
                        dispatch(addErrorAlert("Marketing consent cannot be updated"));
                    }));
                }else {
                    onDone();
                }
            }}
        />
    </div>
}

const styles = {
    container: {
        color: '#000',
        padding: '2rem',
        margin: '2rem auto',
        borderRadius: '0.71rem',
        background: 'white',
        textAlign: 'left',
    },
    icon: {
        height: '2.14rem',
        margin: '0 1.71rem -0.29rem'
    },
    title: {
        fontSize: '1.5rem',
        fontWeight: '700',
        marginBottom: '1rem',
    },
    mainText: {
        fontSize: '1.2rem',
        fontWeight: '400',
    },
    highlight: {
        color: '#3f28dd',
        fontWeight: '700',
    },
    disclaimer: {
        fontSize: '0.8rem',
        marginTop: '1.5rem',
        textAlign: 'left',
        color: '#444',
    }
};
